// Logo component for CASHBACKHUB - matches image 2
import logoImage from '../assets/images/logo.png';

const Logo = ({ className = '' }: { className?: string }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img 
        src={logoImage} 
        alt="CASHBACKHUB Logo" 
        className="h-8 w-auto"
      />
    </div>
  );
};

export default Logo;

